React = require 'react'
FormFields = require './internal/form-fields'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
_ = require 'underscore'
xtend = require 'xtend'
f = require 'effing'
{ formatMoney } = require 'app/scripts/lib/format/money'
formatNumber = require 'app/scripts/lib/format/number'
{ track } = require '@trello/analytics'

module.exports = class extends React.Component
  displayName: 'ProductsComponent'

  formFields: ['products']
  requiredFields: []

  render: t.renderable ->
    { productName, monthlyProduct, yearlyProduct, billingStrategy, setBillingPlan, selectedBillingPlan } = @props

    if selectedBillingPlan && monthlyProduct
      isMonthly = selectedBillingPlan.toString() == monthlyProduct.productNumber.toString()

    trackBCPlan = (e) ->
      if e.target.value
        bcPlan = switch e.target.value
          when '105' then 'Monthly'
          when '106' then 'Annual'
          when '110' then 'Monthly'
          when '111' then 'Annual'
          else 'Unknown'
        track 'Organization View', 'Business Class Page', bcPlan + ' Billing Button'

    render = ({ form }) =>
      controlledRadio = f(t, 'radio', form)

      t.div '.u-clearfix.billing-products-component', ->
        t.h1 '.subscribe-title', ->
          if productName?
            t.format 'subscribe-to-productname', { productName }

        t.h3 '.billing-plan-title', ->
          t.format 'billing-plan'

        t.div '.u-clearfix.billing-plans-wrap', ->
          t.div '.u-clearfix.billing-plan.yearly-plan', ->
            t.label { onClick: trackBCPlan }, ->
              controlledRadio 'products', [yearlyProduct.productNumber.toString()], -> setBillingPlan(yearlyProduct.productNumber.toString())
              t.span '.radio'
              t.h4 ->
                t.format 'billed-annually'
              t.strong '.monthly-price', ->
                t.text '$' + formatMoney yearlyProduct.price / 12
              t.span '.save-losenge.small', ->
                t.format 'save-percent',
                  savePercent: formatNumber yearlyProduct.savePercent
              t.span '.small.clear', ->
                t.format (if billingStrategy.perUser then 'per-user-per-month' else 'per-month')

          t.div '.u-clearfix.billing-plan.monthly-plan', ->
            t.label { onClick: trackBCPlan }, ->
              controlledRadio 'products', [monthlyProduct.productNumber.toString()], -> setBillingPlan(monthlyProduct.productNumber.toString())
              t.span '.radio'
              t.h4 ->
                t.format 'billed-monthly'
              t.strong '.monthly-price', ->
                t.text '$' + formatMoney monthlyProduct.price
              t.span '.small.clear', ->
                t.format (if billingStrategy.perUser then 'per-user-per-month' else 'per-month')

        if isMonthly
          t.span '.switch-to-annual.small', ->
            t.format 'save-annual-billing',
              savePercent: yearlyProduct.savePercent

        if billingStrategy.perActiveUser
          t.p '.u-quiet', ->
            t.format 'smart billing explanation recently active'

    t.tag FormFields, {
      render
      @formFields
      @requiredFields
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      initialState: {
        products: [@props.defaultProduct.toString()]
      }
    }
